<template>
    <button @click="$emit('click')"
            data-link="menu"
            type="button"
            class="mobile-back">
        <svg width="19" height="10" viewBox="0 0 19 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.5024 0.193236C18.2448 -0.0644125 17.8261 -0.0644125 17.5684 0.193236L9.35588 8.4219L1.12721 0.193236C0.869565 -0.0644125 0.450886 -0.0644125 0.193237 0.193236C-0.0644123 0.450885 -0.0644123 0.869565 0.193237 1.12721L8.87279 9.80676C9.00161 9.93559 9.16264 10 9.33978 10C9.50081 10 9.67794 9.93559 9.80676 9.80676L18.4863 1.12721C18.7601 0.869565 18.7601 0.450885 18.5024 0.193236Z"/>
        </svg>
    </button>
</template>

<script>
    export default {
        name: "ButtonBack",
        props: {
            openGroup: String,
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/mixins/breakpoint";
    @import "../../../../../scss/variables";

    .mobile-back {
        display: -webkit-flex;
        display: flex;
        align-items: center;
        -webkit-align-items: center;
        justify-content: center;
        -webkit-justify-content: center;
        text-align: center;
        float: left;
        width: 60px;
        height: 75px;
        background-color: #212121;
        border: 0 none;
        cursor: pointer;

        @include only-mobile-breakpoint() {
            height: $mobileHeaderHeight;
        }

        & svg {
            transform: rotate(90deg);
            color: #ffffff;
            fill: #ffffff;
        }

        &:hover {
            background-color: #111111;
        }

        &.white {
            background-color: #eeeeee;
        }

        &.white svg {
            color: #666666;
            fill: #666666;
        }

        &.white:hover {
            background-color: #212121;
        }

        &.selected:before {
            content: '';
            display: none;
        }
    }
    @media (max-width: 1000px) {
        .mobile-back.white {
            width: 40px;
        }
    }
</style>